import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../css/Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/admin/management/stores', label: '가맹점관리' },
    { path: '/admin/management/customers', label: '고객관리' },
    { path: '/admin/management/reservations', label: '예약관리' },
    { path: '/admin/management/reports', label: '신고관리' },
    { path: '/admin/management/coupons', label: '쿠폰 관리' },
    { path: '/admin/management/notifications/marketing', label: '마케팅 푸시' },
    { path: '/admin/management/accounts', label: '계정관리' },
    { path: '/admin/management/systems', label: '시스템/보안관리' },
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <header className="admin-header">
      <nav className="admin-nav">
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  );
};

export default Header;
